import { environment as env } from '@env/environment';

/**
 * Config variables
 */
export const config = {
  production: env.production,
  apiBaseUrl: env.apiBaseUrl,
  localConfig: env.localConfig,
  socketIo: env.socketIo,
};

//SLOTS
export const slots: boolean = true;
//NORMAS
export const normasNOVAPETUrl: string = 'https://expediciones.samca.com/brilen-novapet/uploads/NormasBRILEN-NOVAPET.pdf';
export const normasTIM_AGROTIMUrl: string = 'https://expediciones.samca.com/brilen-novapet/uploads/NormasTIM-AGROTIM.pdf';
//TRASPORT TEST 
export const validateTransportTest: boolean = false // Obtenemos un transporte de prueba





